<template>
  <div
    class="py-2"
  >
    <v-row 
      no-gutters
      class="pl-5 mt-n3 font-16 font-weight-bold"
    >
      <v-col>
        Shift
        <setup-work-session-work-session-type-shift-dialog-create
          :work-session-type="workSessionType"
          @created="loadWorkSessionShiftCodes()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :items="workSessionShiftCodes"
          :headers="headers"
          hide-default-footer
          dense
          class="my-2"
          :loading="loading"
          :items-per-page="-1"
        >
          <template v-slot:item.start_time="{ item }">
            {{ $moment(item.start_time, 'hh:mm').format('hh:mm A') }}
          </template>
          
          <template v-slot:item.end_time="{ item }">
            {{ $moment(item.end_time, 'hh:mm').format('hh:mm A') }}
          </template>

          <template v-slot:item.description="{ item }">
            <span
              v-if="item.description"
              v-html="item.description.replace(/\n/g, '</br>')"
            />
            <span v-else>
              - 
            </span>
          </template>

          <template v-slot:item.action="{ item }">
            <setup-work-session-work-session-type-shift-dialog-edit
              :work-session-shift-code="item"
              @updated="loadWorkSessionShiftCodes()"
            />
            <setup-work-session-work-session-type-shift-dialog-delete
              :work-session-shift-code="item"
              @deleted="loadWorkSessionShiftCodes()"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {  
    components: {
      SetupWorkSessionWorkSessionTypeShiftDialogCreate: () => import('@/components/hris/setup/work-session/work-session-type/shift/DialogCreate'),
      SetupWorkSessionWorkSessionTypeShiftDialogEdit: () => import('@/components/hris/setup/work-session/work-session-type/shift/DialogEdit'),
      SetupWorkSessionWorkSessionTypeShiftDialogDelete: () => import('@/components/hris/setup/work-session/work-session-type/shift/DialogDelete'),
    },
    props: {
      workSessionType: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: 'Start Time',
            align: 'center',
            value: 'start_time',
          },
          {
            text: 'End Time',
            align: 'center',
            value: 'end_time',
          },
          {
            sortable: false,
            text: '',
            align: 'center',
            value: 'action',
          },
        ],
        loading: false,
        workSessionShiftCodes: [],
      }
    },

    watch: {
      workSessionType: function (value) {
        if (!value) return
        this.loadWorkSessionShiftCodes()
      },
    },
    created () {
      this.loadWorkSessionShiftCodes()
    },
    methods: {
      loadWorkSessionShiftCodes () {
        this.workSessionShiftCodes = []
        this.loading = true

        this.$api.shiftCodes().list(this.workSessionType.id)
          .then(res => {
            this.workSessionShiftCodes = _.orderBy(res.data, ['start_time'], ['asc'])

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-16{
    font-size:16px;
}
</style>
